import { render, staticRenderFns } from "./ChatTicket.vue?vue&type=template&id=62141584&scoped=true"
import script from "./ChatTicket.vue?vue&type=script&lang=js"
export * from "./ChatTicket.vue?vue&type=script&lang=js"
import style0 from "./ChatTicket.vue?vue&type=style&index=0&id=62141584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62141584",
  null
  
)

export default component.exports